import { createAction, createSetterActions } from "@/redux/helpers/action";

import { MODULE } from "./constants";

export const [setCurrentCompany] = createSetterActions(MODULE, ["currentCompany"]);

export const reset = createAction(`${MODULE}/RESET`);
